import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import isEmpty from 'lodash/isEmpty';

// Components
import Intro from 'components/common/Intro';
import Tabs from 'components/common/Tabs';
import Footer from 'components/common/Footer';
import SingleMediaContent from 'components/media-publications/SingleMediaContent';


class MediaCenter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentSection: props.params.section ? props.params.section : ''
    };
    // Bindings
    this.handleMediaSection = this.handleMediaSection.bind(this);
  }

  componentWillMount() {
    if (!this.props.list.length) {
      this.props.getMediaCenter();
    } else {
      if (!this.props.params.section || this.props.params.section === '') {
        const value = this.sortByPosition(this.props.list)[0].slug;
        this.setState({ currentSection: value });
      }
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.params.section && this.state.currentSection !== newProps.params.section) {
      this.setState({ currentSection: newProps.params.section });
    } else if (newProps.list.length && this.state.currentSection === '') {
      const value = this.sortByPosition(newProps.list)[0].slug;
      this.setState({ currentSection: value });
    }
  }

  handleMediaSection(option) {
    this.setState({ currentSection: option.value }, () => {
      this.props.router.replace(`/media-center/${this.state.currentSection}`);
    });
  }

  createMarkup(content) {
    return { __html: content };
  }

  parseSectionsTabs() {
    return this.props.list.map(l => (
      {
        label: l.title,
        value: l.slug,
        noIcon: true
      }
    ));
  }

  sortByPosition(list) {
    return list.sort((a, b) => a.position - b.position);
  }

  render() {
    const sortedList = this.sortByPosition(this.props.list);
    const mediaCenter = sortedList.find(a => a.slug === this.state.currentSection);
    return (
      <div className="l-main">
        <Intro section="c-intro">
          <div className="row">
            <div className="column small-12 medium-6">
              <h2 className="title -section-title -light">Media Center</h2>
            </div>
          </div>
        </Intro>
        <div className="l-content -about">
          <div className="row justify-content-center">
            <div className="column small-12 medium-3">
              <Tabs
                format="-vertical"
                value={this.state.currentSection}
                options={this.parseSectionsTabs()}
                onChange={this.handleMediaSection}
              />
            </div>
            {mediaCenter && !isEmpty(mediaCenter) ?
              <div className="column small-11 medium-9">
                <div className="column small-12 p-0 ">
                  <h1 dangerouslySetInnerHTML={this.createMarkup(mediaCenter.subtitle)}></h1>
                  <div className="media-subtitle" dangerouslySetInnerHTML={this.createMarkup(mediaCenter.text)}></div>
                </div>
                {(mediaCenter.categorizedMedia || []).map((el, index) => <SingleMediaContent className="column small-12 " {...el} key={index} />)}
              </div>
            : ''}
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

MediaCenter.propTypes = {
  router: PropTypes.object.isRequired,
  params: PropTypes.object,
  list: PropTypes.array,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  // Actions
  getMediaCenter: PropTypes.func,
  setModalContent: PropTypes.func
};

export default withRouter(MediaCenter);



// WEBPACK FOOTER //
// ./app/components/media-center/index.jsx